import NProgress from 'nprogress'

export function enableLoadingState() {
  document.body.classList.add('shw-loading')
  NProgress.start()
}

export function disableLoadingState() {
  document.body.classList.remove('shw-loading')
  NProgress.done()
}
